// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

import { parentCategoriesStyles } from "@gcg/App/Widgets/CategoryTilesDisplay/CategoryTiles.styles";

parentCategoriesStyles.categoryText = {
    css: css`
        display: block;
        margin-bottom: 0;
        width: 100%;
        text-align: center;

        &:focus {
            outline: 0;
        }

        ${/* sc-selector */ TypographyStyle} {
            max-height: 45px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            display: block;
        }
        // XNG-Changes replacing underline with color
        &:hover,
        &:focus ${/* sc-selector */ TypographyStyle} {
            color: ${getColor("common.ui9")};
        }
    `,
};
